// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"8cd26bee","525":"e4d75e24","899":"1257a697"}[chunkId] + ".chunk.js";
};